export default "__VITE_ASSET__8rTk3ubX__"